import { Component, OnInit, signal, inject } from '@angular/core';
import { Router, RouterOutlet } from '@angular/router';
import { VwApiRequestsService, VwAuthService, VwNetworkManagementService } from 'vwappservices';
import { AppStateService } from './services/app-state.service';
import { ConfirmDialogComponent } from './shared/confirm-dialog.component';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, ConfirmDialogComponent],
  templateUrl: './app.html',
  styleUrl: './app.scss',
})
export class App implements OnInit {
  protected readonly title = signal('angular_temp');

  private router = inject(Router);
  private auth = inject(VwAuthService);
  private api = inject(VwApiRequestsService);
  private network = inject(VwNetworkManagementService);
  private appState = inject(AppStateService);

  async ngOnInit() {
    this.api.setUnauthorisedHandler(() => this.router.navigateByUrl('/login'));

    await this.network.getCurrentStatus();

    const restored = await this.auth.restoreSession();
    // restoreSession() only re-obtains the access token — the rest of the profile (role,
    // language, assignments) was cached separately by AppStateService at login time.
    const profile = restored ? this.appState.restoreProfile() : null;
    if (!profile) {
      this.router.navigateByUrl('/login');
    }

    this.installModalBackdropSafetyNet();
  }

  // Master pages reload their list (new array = new object identities) right after a modal
  // action, which can tear down and rebuild a *ngFor'd modal element (via AppendToBodyDirective's
  // ngOnDestroy) while Bootstrap's own fade-out/backdrop-cleanup for a still-open modal is in
  // flight. When that race loses, Bootstrap never gets to remove its backdrop or the body's
  // `modal-open` class, leaving a full-screen, invisible overlay that blocks every click on the
  // page. Rather than chase the exact timing, self-heal on both ends: strip any leftover backdrop
  // right before a new modal opens, and again once a modal finishes closing and nothing else is open.
  private installModalBackdropSafetyNet() {
    const cleanupIfNothingOpen = () => {
      if (document.querySelector('.modal.show')) return;
      document.querySelectorAll('.modal-backdrop').forEach((el) => el.remove());
      document.body.classList.remove('modal-open');
      document.body.style.removeProperty('overflow');
      document.body.style.removeProperty('padding-right');
    };
    document.addEventListener('show.bs.modal', cleanupIfNothingOpen);
    document.addEventListener('hidden.bs.modal', cleanupIfNothingOpen);
  }
}
